import { combineReducers } from '@reduxjs/toolkit';
import { invoicesListReducer } from './list/invoicesList.slices';

export const invoicesReducers = combineReducers({
  invoicesList: invoicesListReducer
});
